import { useCallback, useRef } from 'react';

/**
 * Provides a single-instance function which always returns
 *     the latest input value.
 * @template T
 * @param {T} input
 */
export default function useGetter(input) {
    const valueRef = useRef(input);
    valueRef.current = input;

    return useCallback(() => valueRef.current, []);
}